<template>

    <div class="p-4 3xl:p-6
                bg-gradient-to-b from-gray-850 to-gray-900 rounded-t-xl">
    
        <div class="flex items-center justify-center pb-2">
            <div class="absolute rounded-full h-1 w-10 bg-white/10"/>
        </div>

        <h1 class="flex justify-center px-4 3xl:px-6 pt-2 pb-4 text-base tracking-wider text-center">
            You need to turn on Location Services to find nearby offers
        </h1>

        <div class="flex gap-4 px-2 py-4 mb-2 3xl:mb-4
                    border-2 border-gray-700 rounded-sm
                    rounded-t-xl">
            <div class="pr-4 pl-2">
                <div class="rounded-full bg-gray-750 p-2 aspect-square">
                    <Icon name="apple-logo" class="text-4xl 3xl:text-6xl" />
                </div>
            </div>
            <ul class="text-sm">
                <li class="list-decimal">Open Settings > Privacy > Location Services</li>
                <li class="list-decimal">Select the Carbucks app and set Location access to "While Using the App" or "Always"</li>
            </ul>
        </div>

        <div class="flex gap-4 px-2 py-4 mb-4 3xl:mb-6
                    border-2 border-gray-700 rounded-sm
                    rounded-b-xl">
            <div class="pr-4 pl-2">
                <div class="rounded-full bg-gray-750 p-2 aspect-square">
                    <Icon name="android-logo" class="text-4xl 3xl:text-6xl" />
                </div>
            </div>
            <ul class="text-sm">
                <li class="list-decimal">Open Settings > Apps</li>
                <li class="list-decimal">Select the Carbucks App > Permissions</li>
                <li class="list-decimal">Tap Location and choose "Allowed only while in use" or "Allowed all the time"</li>
            </ul>
        </div>
        
        <p class="text-center opacity-60">
            The app is better when you have<br/>Location Services enabled on your device
        </p>

    </div>

</template>